
import React from 'react';
import { cn } from "@/lib/utils";
import { getContentType } from '@/utils/component-type-utils';

interface GridCellProps {
  content: any;
  rowIndex: number;
  itemIndex: number;
  arrayIndex: number;
  isMobile: boolean;
}

export function GridCell({ content, rowIndex, itemIndex, arrayIndex, isMobile }: GridCellProps) {
  const contentType = getContentType(content);
  
  // Add more visual distinction between different content types
  const getContentBackgroundStyle = () => {
    if (contentType === "Bulletin" || contentType === "Gradient") {
      return "bg-black/40 backdrop-blur-sm";
    } else if (contentType === "Profile") {
      return "bg-black/60 backdrop-blur-md";
    } else if (contentType === "Link") {
      return "bg-black/30 backdrop-blur-sm";
    } else {
      return "bg-black/40 backdrop-blur-sm";
    }
  };
  
  return (
    <div 
      className={cn(
        "relative w-full overflow-hidden flex items-center justify-center", // Added flex, items-center, justify-center for consistent vertical centering
        isMobile
          ? "h-[180px]" // Increased height from 160px to 180px
          : "min-h-[clamp(185px,26.4vh,264px)]"
      )}
    >
      <div className={`absolute inset-0 rounded-lg overflow-hidden ${getContentBackgroundStyle()} group flex items-center justify-center`}> {/* Added flex, items-center, justify-center */}
        {React.isValidElement(content) ? (
          <div className="w-full h-full flex items-center justify-center">
            {content}
          </div>
        ) : content && typeof content === 'object' && 'type' in content ? (
          content.type === 'color' ? (
            <div
              className="absolute inset-0 group-hover:scale-105 transition-transform duration-200"
              style={{
                background: content.style,
                opacity: content.style.includes('gradient') ? 0.6 : 0.7 // Increased opacity for better visibility
              }}
            />
          ) : null
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground">
            {content}
          </div>
        )}
      </div>
    </div>
  );
}
